import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
    faCalendarPlus,
    faCalendarCheck,
    faCalendarXmark,
    faCalendarCircleExclamation,
    faCalendarCircleUser,
    faUserPlus,
    faUserTag,
    faUserCheck,
    faPaw,
    faBoxOpen,
    faBoxArchive,
    faBoxesStacked,
    faReceipt,
    faBell,
    faCakeCandles,
    faSyringe,
    faCartShopping,
    faClockRotateLeft
} from '@fortawesome/pro-solid-svg-icons';

/**
 * Icons only — the event and anchor catalogs come from the backend (see
 * `useAutomationOptions`). FontAwesome icon objects can't cross the wire, so
 * the backend sends a stable key and this maps it to a glyph.
 */

const FALLBACK_EVENT_ICON = faBell;

export const EVENT_ICONS: Record<string, IconDefinition> = {
    appointment_booked: faCalendarPlus,
    appointment_accepted: faCalendarCircleUser,
    appointment_confirmed: faCalendarCheck,
    appointment_completed: faCalendarCheck,
    appointment_closed: faCalendarCheck,
    appointment_cancelled: faCalendarXmark,
    appointment_no_show: faCalendarCircleExclamation,
    client_created: faUserPlus,
    client_converted: faUserCheck,
    lead_created: faUserTag,
    pet_added_to_client: faPaw,
    membership_started: faBoxOpen,
    membership_package_consumed: faBoxesStacked,
    enrollment_credits_low: faBoxArchive,
    invoice_charged: faReceipt
};

export const ANCHOR_ICONS: Record<string, IconDefinition> = {
    appointment_starts_at: faCalendarPlus,
    appointment_ends_at: faCalendarCheck,
    last_appointment_at: faClockRotateLeft,
    vaccine_expires_at: faSyringe,
    membership_renews_at: faBoxOpen,
    package_expires_at: faBoxArchive,
    pet_birthday: faCakeCandles,
    client_anniversary: faCakeCandles,
    booking_attempt_abandoned_at: faCartShopping
};

export const eventIcon = (key: string): IconDefinition => EVENT_ICONS[key] ?? FALLBACK_EVENT_ICON;

export const anchorIcon = (key: string): IconDefinition => ANCHOR_ICONS[key] ?? FALLBACK_EVENT_ICON;
